export function isEsimOnly(simType?: string | null) {
  return simType?.trim().toLowerCase() === 'esim'
}

/**
 * SIM type labels come from the catalog as localized display strings
 * (e.g. "Physical SIM + eSIM", "SIM physique + eSIM"). Keep matching on both
 * French and English until the catalog exposes a structured SIM capability.
 */
export function isPhysicalAndEsim(simType?: string | null) {
  const normalizedSimType = simType?.toLowerCase() ?? ''

  return (
    (normalizedSimType.includes('physical') ||
      normalizedSimType.includes('physique')) &&
    normalizedSimType.includes('esim')
  )
}

export function isPhysicalOnly(simType?: string | null) {
  return Boolean(simType) && !isEsimOnly(simType) && !isPhysicalAndEsim(simType)
}
